import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { Tax } from '../model/prices.model'

export const initialState = {
  data: {
    tax: {
      name: 'IVA',
      value: 1.21,
      id: '2',
    },
  },
}

export const pricesSlice = createSlice({
  name: 'masterData',
  initialState,
  reducers: {
    setTaxData(state, action: PayloadAction<Tax>) {
      return { data: { tax: action.payload } }
    },
    resetPrices() {
      return initialState
    },
  },
})

export const { setTaxData, resetPrices } = pricesSlice.actions

const pricesReducer = pricesSlice.reducer
export default pricesReducer
